import {
  type GetWrappedInsightsResponse,
  getWrappedInsightsResponseSchema,
} from "@clipboard-health/contract-worker-app-bff";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { minutesToMilliseconds } from "date-fns";

export function useGetCbhWrappedInsights(
  options: UseGetQueryOptions<GetWrappedInsightsResponse> = {}
): UseQueryResult<GetWrappedInsightsResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/wrapped-insights`,
    responseSchema: getWrappedInsightsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CBH_WRAPPED_GET_INSIGHTS_FAILURE,
    },
    staleTime: minutesToMilliseconds(5),
    ...options,
  });
}
